import * as breakpoints from './responsive-breakpoints.module.scss'

export const PHONE_VERTICAL_END = parseInt(breakpoints['phoneVerticalEnd'], 10)
export const PHONE_HORIZONTAL_END = parseInt(breakpoints['phoneHorizontalEnd'], 10)
export const TABLET_VERTICAL_END = parseInt(breakpoints['tabletVerticalEnd'], 10)
export const TABLET_HORIZONTAL_END = parseInt(breakpoints['tabletHorizontalEnd'], 10)
export const LARGE_DESKTOP_START = parseInt(breakpoints['largeDesktopStart'], 10)
